/** Steps項目 */
export const C400_STEPS_ITEMS = [
  { label: '提案登録' },
  { label: '提案内容確認' },
  { label: '登録完了' },
];
